var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { TableRowNoData, TableRow, ExpandedTable, TableHeader } from './Tables';
import PropTypes from 'prop-types';

var TableWidget = function (_Component) {
  _inherits(TableWidget, _Component);

  function TableWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableWidget.__proto__ || Object.getPrototypeOf(TableWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expandedIndex: null
    }, _this.handleExpandRow = function (key) {
      _this.setState(function (prevState) {
        return {
          expandedIndex: prevState.expandedIndex === key ? null : key
        };
      });
    }, _this.renderItem = function (item, index) {
      var itemRows = [];
      var expandedIndex = _this.state.expandedIndex;

      // check if selected row in the table is even,
      // that way we can specify a unique class name for the expanded rows as well
      // Makes it easier to handle the css for the expanded rows that are related to the selected row

      var expandedTableHasEvenIndex = expandedIndex === index && index % 2 === 0;

      itemRows = [React.createElement(TableRow, {
        tableType: _this.props.tableType,
        onExpand: function onExpand() {
          return _this.handleExpandRow(index);
        },
        item: item,
        active: expandedIndex === index,
        evenTableRow: index % 2 === 0
      })];

      if (expandedIndex === index) {
        itemRows.push(React.createElement(ExpandedTable, {
          tableType: _this.props.tableType,
          item: item,
          isSiblingEven: expandedTableHasEvenIndex
        }));
      }
      return itemRows;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TableWidget, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;

      var allItemRows = [];

      data && data.map(function (item, index) {
        var perItemRows = _this2.renderItem(item, index);
        allItemRows = allItemRows.concat(perItemRows);
      });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'table',
          { className: 'table' },
          React.createElement(
            'tbody',
            null,
            allItemRows.length > 0 && React.createElement(TableHeader, { tableType: this.props.tableType }),
            allItemRows
          )
        ),
        allItemRows.length === 0 && React.createElement(TableRowNoData, { tableType: this.props.tableType })
      );
    }
  }]);

  return TableWidget;
}(Component);

TableWidget.propTypes = {
  /** Collection of items */
  data: PropTypes.arrayOf(PropTypes.shape({
    /** The id/name of the bonus */
    Id: PropTypes.number,
    /** Bonus description */
    Description: PropTypes.string,
    /** Amount of bonus money */
    Amount: PropTypes.number,
    /** Type of Bonus */
    Type: PropTypes.string,
    /** Type of currency */
    Currency: PropTypes.string,
    /** Amount of required wagering remaining */
    WageringRequirmentRemaining: PropTypes.number,
    /** Amount of wagering required */
    WageringRequirment: PropTypes.number,
    /** The date of when the bonus expires */
    Expires: PropTypes.string,
    /** Reference to what table it is we want to display, eg Bonus, History etc */
    tableType: PropTypes.string.isRequired
  }))
};

export default TableWidget;